import { Injectable } from '@angular/core';
import * as matcher from './matcher';


@Injectable()
export class TagService {

  filterSuggestions(suggestions: any[], tags: any[],  filter: string): any[] {
    const distinct = this.outersect(suggestions, tags, (t: any) => t.name);
    if (distinct && filter) {
      let searchTerm = filter || '*';
      searchTerm = searchTerm.endsWith('*') ? searchTerm : searchTerm + '*';
      searchTerm = searchTerm.startsWith('*') ? searchTerm : '*' + searchTerm;

      const filtered = distinct.filter(d => matcher.isMatch(d, searchTerm));
      return suggestions.filter((s: any) => filtered.indexOf(s.name) !== -1);
    }
    return [];
  }

  private outersect<T, U>(a: T[], b: T[], mapFn: (value: T, index: number, array: T[]) => U): U[] {
    return a.map(mapFn).filter(value => b.map(mapFn).indexOf(value) === -1);
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/questions/tagsComponent/tag.service.ts